var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CardBasicInfoThumbnail",style:(_vm.backgroundImage)})
}
var staticRenderFns = []

export { render, staticRenderFns }